import React, { useEffect } from "react";
import { hasPermissionToActionButton } from "../../lib/utils";
import { useRole } from "../../contexts/RoleContext";
import { useLocation } from "react-router-dom";
import { Bell, CreditCard, Edit, PackageOpen, Trash2 } from "lucide-react";

function ActionButton({ openModal, item, handleDelete, setPermission }) {
  const location = useLocation();
  const pathname = location.pathname;
  const { role, loading } = useRole();

  const permission = hasPermissionToActionButton(role, pathname);
  useEffect(() => {
    setPermission(permission);
  }, []);
  return (
    <div className="flex justify-start space-x-2 pt-2">
      {permission.view && (
        <button
          onClick={() => openModal(item, "view")}
          className="p-2 text-gray-500 hover:text-gray-700 rounded-md hover:bg-gray-100"
        >
          <PackageOpen className="h-4 w-4"/>
        </button>
      )}
      {permission.update && (
        <button
          onClick={() => openModal(item, "edit")}
          className="p-2 text-blue-500 hover:text-blue-700 rounded-md hover:bg-blue-50"
        >
          <Edit className="h-4 w-4" />
        </button>
      )}
      {permission.delete && (
        <button className="p-2 text-red-500 hover:text-red-700 rounded-md hover:bg-red-50" onClick={() => handleDelete.onOpen(item)}>
          <Trash2 className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}

export default ActionButton;
